import { render, staticRenderFns } from "./TheUserResourceAdmin.vue?vue&type=template&id=6159fe14&"
import script from "./TheUserResourceAdmin.vue?vue&type=script&lang=js&"
export * from "./TheUserResourceAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports